import {Vector3,Quaternion} from 'three';

export function createHeadLook(head){
  const authored=head.quaternion.clone();let applied=false;
  return {
    restore(){if(applied)head.quaternion.copy(authored);},
    apply(angle){authored.copy(head.quaternion);head.rotateY(angle);applied=true;}
  };
}

// Animation blending is performed in local joint space. This final two-joint
// solve keeps the snowboard boots attached while the upper body blends poses.
export function createFootLock(character,ankleZ=-.095) {
  character.updateWorldMatrix(true,true);
  const legs=[['L',.25],['R',-.25]].map(([side,x])=>{
    const thigh=character.getObjectByName('thigh'+side),shin=character.getObjectByName('shin'+side),foot=character.getObjectByName('foot'+side);
    if(!thigh||!shin||!foot)throw new Error('Missing rider leg '+side);
    return {thigh,shin,foot,x};
  });
  const hip=new Vector3(),knee=new Vector3(),ankle=new Vector3(),target=new Vector3(),direction=new Vector3(),bend=new Vector3(),newKnee=new Vector3(),before=new Vector3(),after=new Vector3();
  const rotation=new Quaternion(),world=new Quaternion(),parent=new Quaternion(),footRotation=new Quaternion();
  function aim(bone,from,to) {
    rotation.setFromUnitVectors(from.normalize(),to.normalize());
    bone.getWorldQuaternion(world);rotation.multiply(world);
    bone.parent.getWorldQuaternion(parent).invert();bone.quaternion.copy(parent.multiply(rotation));bone.updateWorldMatrix(false,true);
  }
  return ()=>{
    character.updateWorldMatrix(true,true);
    for(const leg of legs) {
      leg.thigh.getWorldPosition(hip);leg.shin.getWorldPosition(knee);leg.foot.getWorldPosition(ankle);leg.foot.getWorldQuaternion(footRotation);
      const upper=hip.distanceTo(knee),lower=knee.distanceTo(ankle);
      target.set(leg.x,.19,ankleZ);character.localToWorld(target);
      direction.subVectors(target,hip);const distance=Math.min(direction.length(),upper+lower-1e-5);direction.normalize();
      bend.subVectors(knee,hip).addScaledVector(direction,-before.subVectors(knee,hip).dot(direction));
      if(bend.lengthSq()<1e-9)return;
      bend.normalize();const along=(upper*upper-lower*lower+distance*distance)/(2*Math.max(distance,1e-5));
      newKnee.copy(hip).addScaledVector(direction,along).addScaledVector(bend,Math.sqrt(Math.max(0,upper*upper-along*along)));
      before.subVectors(knee,hip);after.subVectors(newKnee,hip);aim(leg.thigh,before,after);
      leg.shin.getWorldPosition(knee);leg.foot.getWorldPosition(ankle);
      before.subVectors(ankle,knee);after.subVectors(target,knee);aim(leg.shin,before,after);
      leg.foot.parent.getWorldQuaternion(parent).invert();leg.foot.quaternion.copy(parent.multiply(footRotation));leg.foot.updateWorldMatrix(false,true);
    }
  };
}
